import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RequestService } from './request.service';
import { ApiService } from './api.service';
import { PromotionItem } from 'src/Model/PromotionItem.interface';

@Injectable({
  providedIn: 'root',
})
export class PromotionItemService {
  private brandId: number;
  private promotionsBackup = new BehaviorSubject<PromotionItem[]>([]);

  promotionsItems$: Observable<PromotionItem[]> =
    this.promotionsBackup.asObservable();

  private lock = false;

  constructor(
    private _requestService: RequestService,
    private apiService: ApiService
  ) {
    this.apiService.getWebcustomer$.subscribe((webCustomer) => {
      if (!webCustomer) return;
      this.brandId = webCustomer.BrandData.BrandId;
      this.initatePromotionItems();
    });

    this._requestService.cartCounter$.subscribe(() => {
      if (this.lock) {
        this.lock = false;
        return;
      }
      this.updateAddedToCart();
      this.updateRecipeLockStatus();
    });
  }

  private initatePromotionItems() {
    const data = this.promotionsBackup.getValue();
    if (!data.length) {
      this.getPromotionsItems();
    }
  }

  private getPromotionsItems() {
    this._requestService
      .getRequest('api/PromotionItems/getPromotionItems/' + this.brandId)
      .subscribe((res) => {
        if (res.Info.Status == 200) {
          let data = res.Data as PromotionItem[];

          //Data required for cart to keep track of promotion items
          data = data
            .filter((d) => d.Status === true)
            .sort((a, b) => a.MinOrderAmount - b.MinOrderAmount);

          data.forEach((item) => {
            item.RecipeDetails.isPromotionItem = true;
            item.RecipeDetails.PromotionItemId = item.PromotionItemId;
          });

          console.log('Promotion Items:', data); // Log the promotion items to the console

          this.promotionsBackup.next(data);
          this.removeStaleItemsFromCart();
          this.updateAddedToCart();
          this.updateRecipeLockStatus();
        }
      });
  }

  private updateAddedToCart() {
    // Create a Set of unique keys combining RecipeId and the required isPromotionItem status
    const cartItemLookup = new Set(
      this._requestService
        .getCartRecipeItems()
        .map((r) => `${r.RecipeId}-${r.PromotionItemId}`)
    );

    this.promotionsBackup.getValue().forEach((item) => {
      // Check if the recipe exists in the cart WITH isPromotionItem = false
      const lookupKey = `${item.FK_RecipeId}-${item.PromotionItemId}`;

      if (cartItemLookup.has(lookupKey)) {
        item.RecipeDetails.isAddedToCart = true;
      } else {
        item.RecipeDetails.isAddedToCart = false;
      }
    });

    this.promotionsBackup.next(this.promotionsBackup.getValue());
  }

  private updateRecipeLockStatus() {
    const cartItems = this._requestService.getCartRecipeItems();
    const cartTotal = cartItems.reduce(
      (total, item) => total + item.recipeTotal,
      0
    );

    this.promotionsBackup.getValue().forEach((item) => {
      if (cartTotal >= item.MinOrderAmount) {
        item.RecipeDetails.isLocked = false;
      } else {
        item.RecipeDetails.isLocked = true;
        item.RecipeDetails.isAddedToCart = false;

        // Check if this specific promotion recipe is currently in the cart
        const cartEntry = cartItems.findIndex(
          (c) =>
            c.RecipeId === item.RecipeDetails.RecipeId &&
            c.isPromotionItem === true &&
            c.PromotionItemId === item.PromotionItemId
        );

        // If it exists in cart and is now locked, remove it
        if (cartEntry > -1) {
          cartItems.splice(cartEntry, 1);
        }
      }
    });
    this.lock = true;
    this._requestService.saveRecipeCartItems(cartItems);
    this.promotionsBackup.next(this.promotionsBackup.getValue());
  }

  private removeStaleItemsFromCart() {
    const cartItems = this._requestService.getCartRecipeItems();

    const promos = this.promotionsBackup.getValue();

    for (let index = 0; index < cartItems.length; index++) {
      const item = cartItems[index];

      if (!item.isPromotionItem || !item.PromotionItemId) continue;

      const promo = promos.findIndex(
        (p) =>
          p.FK_RecipeId == item.RecipeId &&
          item.PromotionItemId == p.PromotionItemId
      );

      if (promo < 0) {
        this.lock = true;
        cartItems.splice(index, 1);
        this._requestService.saveRecipeCartItems(cartItems);
      }
    }
  }
}
